/**
 * Platform detection for the "add to home screen" step. Browsers do not agree
 * on how installing works, so the guide has to differ per platform.
 */

const ua = navigator.userAgent

/** iPadOS 13+ reports itself as a Mac, so touch points settle it. */
export function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

export function isAndroid() {
  return /Android/.test(ua)
}

/** True once the app runs from the home screen rather than a browser tab. */
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  )
}

export function platform() {
  if (isStandalone()) return 'standalone'
  if (isIOS()) return 'ios'
  if (isAndroid()) return 'android'

  return 'desktop'
}

/**
 * Chrome fires beforeinstallprompt before the UI is ready, so it is captured
 * here at module load and replayed when the user reaches the install step.
 */
let deferredPrompt = null

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  deferredPrompt = event
})

export function canPromptInstall() {
  return deferredPrompt !== null
}

export async function promptInstall() {
  if (deferredPrompt === null) {
    return 'unavailable'
  }

  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  deferredPrompt = null

  return outcome
}
